import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Loader } from '../../../../../common/elements';

import JobOverview from './JobOverview';
import { CvAdvert } from './CvAdvert';
import { JobDescription } from './JobDescription';
import { updateTodoList } from '../../../../../../actions/todo_list/todo_list';

class JobView extends Component {

    openInNewWindow = url => {

        this.props.logExternal( this.props.job.id );
        this.props.updateTodoList( localStorage.getItem( 'person_id' ), 2 );

        window.open( url, '_blank' ).focus();
    };

    thirdPartyLogo = () => {
        if( this.props.job && this.props.job.third_party_logo ){
            return (
                <div className="col-12 logo-hold">
                     <img
                        className="logo-company-job-overview"
                        src={this.props.job.third_party_logo}
                        alt="third party logo"
                    />
                </div>
            );
        };
    };

    render() {
        if( !this.props.job || !Object.keys( this.props.job ).length ){ return <Loader  /> };
        
        return (
            <section className="container job-view">
                <div className="row">{ this.thirdPartyLogo() }</div>
                <div className="row jobs-container">
                    <div className="col-12 col-lg-4 article-sidebar" id="cv-sidebar">
                        <div  className="job-information__container">
                            <JobOverview
                                job={ this.props.job }
                                openInNewWindow={ url  => this.openInNewWindow( url ) }
                                addJobToFavourites={ this.props.addJobToFavourites }
                                removeJobFromFavourites={ this.props.removeJobFromFavourites }/>
                            <CvAdvert job={ this.props.job } registerInterest={ this.props.registerInterest }/>
                        </div>
                    </div>
                    <article className="col-12 col-lg-8 article-info">
                        <h3 className="heading-two">{ this.props.job.title }</h3>
                        <JobDescription job={ this.props.job } />
                    </article>
                </div>
            </section>
        );
    };
}

const mapDispatchToProps = dispatch => ({ updateTodoList : ( personId, listItem ) => dispatch( updateTodoList( personId, listItem ) ) });

JobView.propTypes = {
    job              : PropTypes.object,
    registerInterest : PropTypes.func,
    sticky           : PropTypes.bool
};

export default connect( null, mapDispatchToProps )( JobView );



// WEBPACK FOOTER //
// src/client/components/site/features/jobs/pages/elements/JobView.js